import { Suspense } from 'react';
import { Role } from '../Common/Role';
import { AppDrawer } from '../Common/drawer';
import { safeLazy } from '../SafeLazy/SafeLazy';

const AdminDrawer = safeLazy(() => import('../Admin/Drawer/drawer.items'));
const UserDrawer = safeLazy(() => import('../User/Drawer/drawer.items'));

const Drawer = () => {
  return (
    <AppDrawer>
      <Suspense>
        <Role admin readOnlyAdmin>
          <AdminDrawer />
        </Role>
        <Role customer supplier industry employee>
          <UserDrawer />
        </Role>
      </Suspense>
    </AppDrawer>
  );
};

export default Drawer;
